import { InputProps, Inputs } from "..";
import * as S from "./InputDate.style";
import { ChangeEvent } from "react";

interface InputDateProps extends InputProps {
  startName?: string;
  endName?: string;
  defaultValue?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const InputDate = ({
  id,
  label,
  size,
  width,
  direction,
  errored,
  erroredTxt,
  startName,
  endName,
  onChange,
  defaultValue,
  register,
  disabled,
  value,
}: InputDateProps) => {
  return (
    <Inputs
      id={id && id}
      label={label && label}
      size={size}
      width={width}
      direction={direction}
      errored={errored}
      erroredTxt={erroredTxt}
    >
      <S.InputDateBox>
        <input
          name={startName}
          type="date"
          onChange={onChange}
          defaultValue={defaultValue}
          disabled={disabled}
          value={value}
          {...register}
        />
      </S.InputDateBox>
    </Inputs>
  );
};

// export const InputDate = (props: InputProps) => {
//   return (
//     <Inputs
//       id={props.id && props.id}
//       label={props.label && props.label}
//       size={props.size}
//       width={props.width}
//       direction={props.direction}
//       errored={props.errored}
//       erroredTxt={props.erroredTxt}
//     >
//       <S.InputDateBox>
//         <input type="date" placeholder={props.placeholder} />
//         {props.endDate && (
//           <>
//             ~
//             <input type="date" />
//           </>
//         )}
//       </S.InputDateBox>
//     </Inputs>
//   );
// };
